import { useGetDashboardStat } from 'common/queries-and-mutations/general';
import StatCard from 'components/Cards/UserDashboard/StatCard';
import { Loader } from 'components/Loader';
import React from 'react';

export default function Stats() {
  const { data, isLoading } = useGetDashboardStat();

  return (
    <div className="my-5 grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-4">
      <div className="col-span-12 flex space-x-5 overflow-x-auto px-[var(--margin-x)] transition-all duration-[.25s] scrollbar-hide">
        {isLoading && !data ? (
          <div className="mt-10 flex flex-col items-center justify-center">
            <Loader color={'#FF6606'} height={50} width={50} />
          </div>
        ) : (
          (data ?? [])?.map(stat => (
            <StatCard
              progress={stat.totalAssigned ?? 0 / stat.totalAccount ?? 0}
              key={stat.pageId}
              icon={stat.icon}
              name={stat.name}
              totalAccount={stat.totalAccount}
              totalBeneficiary={stat.totalBeneficiary}
              pageUrl={stat.pageUrl}
            />
          ))
        )}
      </div>
    </div>
  );
}
